<template>
  <div class="px-10px pt-10px text-14px">
    <div class="h-160px border border-hex-4d9bbf border-solid relative pt-35px px-18px">
      <div
        class="h-25px w-60px flex items-center justify-center text-hex-03ffec border-2px border-solid border-hex-03ffec rounded-2px absolute right-0 top-0 bg-hex-0e1e26 text-12px"
      >
        人员详情
      </div>
      <div class="h-100px flex text-white">
        <div class="w-100px h-full mr-15px">
          <img
            class="w-full h-full object-contain border border-gray-500/20"
            :src="personnelDetail.avatar ? personnelDetail.avatar : null"
            alt
          />
        </div>
        <div class="flex flex-col justify-between">
          <div class="flex">
            <div class="text-hex-45f2eb mr-5px">姓名</div>
            <div class="max-w-100px truncate" :title="personnelDetail.name">
              {{ personnelDetail.name }}
            </div>
          </div>
          <div class="flex">
            <div class="text-hex-45f2eb mr-5px">部门</div>
            <div class="max-w-100px truncate" :title="personnelDetail.department">
              {{ personnelDetail.department }}
            </div>
          </div>
          <!-- <div class="flex" v-if="personnelDetail.userPosts.length > 0">
            <div class="text-hex-45f2eb mr-5px">岗位</div>
            <div class="max-w-100px truncate" :title="personnelDetail.userPosts">
              {{ personnelDetail.userPosts }}
            </div>
          </div> -->
        </div>
      </div>
    </div>
    <div class="my-20px text-white">
      <div class="flex h-30px items-center">
        <div class="text-hex-45f2eb w-60px mr-10px">手机号码</div>
        <div class="truncate max-w-215px" :title="personnelDetail.phoneNumber">
          {{ personnelDetail.phoneNumber }}
        </div>
      </div>
      <div v-if="personnelTicketsHref">
        <span
          class="cursor-pointer text-hex-45f2eb underline hover:text-white"
          @click="personnelTicketDetailVis = true"
          >两票信息</span
        >
      </div>
    </div>
    <div class="flex text-white text-16px justify-between mb-30px">
      <div
        class="flex items-center justify-center w-90px h-33px cursor-pointer"
        :class="currentBtn === 'trajectory' ? 'btn_choosed' : 'btn_normal'"
        @click="searcheTrajectory"
      >
        轨迹查询
      </div>
      <div
        class="flex items-center justify-center w-90px h-33px cursor-pointer"
        :class="currentBtn === 'peopleNearby' ? 'btn_choosed' : 'btn_normal'"
        @click="nearbyPeople"
      >
        附近的人
      </div>
      <div
        class="flex items-center justify-center w-90px h-33px cursor-pointer"
        :class="currentBtn === 'locationTracking' && isFollow ? 'btn_choosed' : 'btn_normal'"
        @click="track"
      >
        {{ isFollow ? '取消追踪' : '位置追踪' }}
      </div>
    </div>
    <div v-if="currentBtn === 'peopleNearby'" class="text-white">
      <div class="head-bg h-36px pl-20px flex items-center">附近的人</div>
      <div class="area-box h-280px text-14px overflow-y-auto">
        <el-row type="flex" align="middle" class="h-36px table-choosed">
          <el-col :span="6" class="text-center">姓名</el-col>
          <el-col :span="6" class="text-center">所属部门</el-col>
          <el-col :span="6" class="text-center">距离</el-col>
          <el-col :span="6" class="text-center">操作</el-col>
        </el-row>
        <el-row
          type="flex"
          align="middle"
          class="h-36px table-choosed"
          v-for="item in showNearbyList"
          :key="item.id"
        >
          <el-col :span="6" class="truncate text-center" :title="item.name">{{ item.name }}</el-col>
          <el-col :span="6" class="truncate text-center" :title="item.department">
            {{ item.department }}
          </el-col>
          <el-col :span="6" class="truncate text-center" :title="item.distance + 'm'"
            >{{ item.distance }}m</el-col
          >
          <el-col
            :span="6"
            class="truncate cursor-pointer text-center"
            @click.native="getDetail(item)"
            >详情</el-col
          >
        </el-row>
      </div>
      <el-pagination
        class="float-right pr-6px page-theme flex"
        background
        small
        @current-change="handlePageChange"
        :current-page.sync="nearByPage.pageNo"
        layout="slot, prev, pager, next"
        :page-size.sync="nearByPage.pageSize"
        :total="nearByPage.total"
      >
        <template>
          <div class="inline-block h-24px leading-24px text-15px">
            共
            <span class="!leading-22px text-center text-hex-fbaf3d">{{ nearByPage.total }}</span
            >条数据
          </div>
        </template>
      </el-pagination>
    </div>
    <div v-if="currentBtn === 'locationTracking' && isFollow" class="text-white">
      <div class="head-bg h-36px pl-20px flex items-center">所在区域</div>
      <!-- <el-row
        type="flex"
        align="middle"
        class="h-36px table-choosed"
        v-for="item in personnelBelongAreaName"
        :key="item.id"
      >
        <el-col :span="24" class="truncate text-center" :title="item.name">{{ item.name }}</el-col>
      </el-row> -->
      <el-row
        type="flex"
        align="middle"
        class="h-36px table-choosed"
      >
        <el-col :span="24" class="truncate text-center">{{ personnelBelongAreaName }}</el-col>
      </el-row>
      <!-- <CategoryTitle title="视频联动" />
      <MonitorPlayer
        v-if="currentMonitor"
        :manufacturerCode="currentMonitor.manufacturerCode"
        :daHuaParams="{
          id: currentMonitor.id,
          code: currentMonitor.code,
        }"
        :code="currentMonitor.code"
        :name="currentMonitor.name"
        :pIid="currentMonitor.pIid"
        :showControlPanel="false"
        class="h-210px mt-15px"
      /> -->
    </div>
    <personnel-ticket-details
      v-if="personnelTicketDetailVis"
      @close="personnelTicketDetailVis = false"
      :title="'两票信息'"
      :iframeUrl="personnelTicketsHref"
      :monitorList="monitorList"
    />
  </div>
</template>

<script>
import { EafOrganizationUnitUserApi } from '@wiz-api/account'
import { AreaApi } from '@wiz-api/area-management'
import { FileApi } from '@wiz-api/file-management'
import { PersonnelApi } from '@wiz-api/personnel-position'
// import { PersonnelLocationApi } from '@wiz-api/huizhou2'
import { PersonnelLocationApi } from '@wiz-api/dyw'
import { isEmpty, head, find, filter, map, forEach, get, isEqual } from 'lodash'
import { IOTDeviceApi, Tag3DCameraPositionsApi } from '@wiz-api/iot-device-management'
import personnelList from '../../assets/js/componentMethods/personnelList'

const eafOrganizationUnitUserApi = new EafOrganizationUnitUserApi()
const areaApi = new AreaApi()
const fileApi = new FileApi()
const personnelApi = new PersonnelApi()
const personnelLocationApi = new PersonnelLocationApi()
const tag3DCameraPositionsApi = new Tag3DCameraPositionsApi()
const iOTDeviceApi = new IOTDeviceApi()

const personnelTicketDetails = () => {
  return import('./components/PersonnelTicketDetails')
}
const MonitorPlayer = () => {
  return import('./components/video/MonitorPlayer')
}
const CategoryTitle = () => {
  return import('@/components/cockpit/CategoryTitle')
}

export default {
  components: {
    personnelTicketDetails,
    MonitorPlayer,
    CategoryTitle,
  },
  props: {
    transferProps: {
      type: Object,
      defalut: () => {
        return {}
      },
    },
    customProps: {
      type: Object,
      defalut: () => {
        return {}
      },
    },
    cloudRender: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      personnelDetail: {
        name: '',
        avatar: null,
        department: '',
        post: '',
        phoneNumber: '',
        userName: '',
      },
      isFollow: false,
      // 默认跟随
      currentBtn: '',
      // 所有人员的信息
      allPersonnelInfo: [],
      // 附近的人列表
      nearbyList: [],
      // 所在风险区域
      personnelBelongAreaName: "",
      // code和id的映射
      codeIdMap: {},
      nearByPage: {
        pageNo: 1,
        pageSize: 10,
        total: 0,
      },
      // 处理数据的标识
      flag: true,
      // 是否查看历史轨迹
      isTrajectory: false,
      // 两票信息
      personnelTicketDetailVis: true,
      currentMonitor: null,
      currentPosition: {
        x: 0,
        y: 0,
        z: 0,
      },
      oldPosition:{
        x:0,
        y:0,
        z:0
      },
      followTimer: null,
      monitorList: [],
      initPagination: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
      },
      search: {
        status: '',
        keyWord: '',
      },
      currentPersonAreaNameitv:null,
    }
  },
  computed: {
    // 驾驶舱配置
    modelSetting() {
      return Wiz.globalSettings.dynamicModules.modules['visualization-cockpit-tongre']?.config
    },
    nearbyNumber() {
      return this.modelSetting?.cameraListConfig?.nearbyNumber || 10
    },
    personnelTicketsHref() {
      const config =
        Wiz.globalSettings.dynamicModules.modules['visualization-cockpit-tongre'].config
          ?.personnelTicketsConfig

      if (!config) return null

      const baseUrl = config.url

      const params = {
        ...config.params,
        gh: config.params.gh ? config.params.gh : this.personnelDetail.userName,
      }
      if (!params.gh) return null

      // 过滤空值并处理参数
      const queryString = Object.entries(params)
        .filter(([_, value]) => {
          return value !== ''
        })
        .map(([key, value]) => {
          // 检查编码次数
          const getEncodeCount = (str) => {
            let decoded = str
            for (let count = 0; count < 3; count += 1) {
              try {
                const temp = decodeURIComponent(decoded)
                if (temp === decoded) return count
                decoded = temp
              } catch {
                return count
              }
            }
            return 2 // 最多认为编码2次
          }

          const encodeCount = getEncodeCount(value)
          let encodedValue = value
          switch (encodeCount) {
            case 0:
              encodedValue = encodeURIComponent(encodeURIComponent(value))
              break
            case 1:
              encodedValue = encodeURIComponent(value)
              break
            default:
              break
          }

          return `${key}=${encodedValue}`
        })
        .filter((param) => {
          return param !== ''
        })
        .join('&')

      return `${baseUrl}?${queryString}`
    },
    personnelId() {
      return this.transferProps.personnelId
    },
    tagCode() {
      return this.transferProps.tagCode
    },
    // 前端分页处理
    showNearbyList() {
      return this.nearbyList.slice(
        (this.nearByPage.pageNo - 1) * this.nearByPage.pageSize,
        this.nearByPage.pageNo * this.nearByPage.pageSize
      )
    },
    // 附近的人最大距离筛选
    nearMaxDistance() {
      return (
        get(Wiz, 'globalSettings.dynamicModules.modules["visualization-cockpit-tongre"].config')
          ?.nearMaxDistance || 5
      )
    },
  },
  watch: {
    transferProps: {
      immediate: true,
      async handler(value) {
        clearInterval(this.currentPersonAreaNameitv)
        this.currentPersonAreaNameitv = null
        // 如果是从历史轨迹的人员标签打开的人员详情弹框
        if (value.isTrajectory) {
          this.currentBtn = 'trajectory'
          this.isTrajectory = true
          if (this.isFollow) {
            // 取消跟随
            await this.cloudRender.PosViewer.cancelPerspectiveFollow()
            this.isFollow = false
          }
        } else {
          // 如果不是从历史轨迹中点击标签打开的，则跟随人员
          if (!this.isFollow) {
            await this.cloudRender.PosViewer.setPerspectiveFollow({
              id: this.tagCode,
              personalPerspective: 2,
              angle: [5, 90],
            })
            this.isFollow = true
          }
          this.currentBtn = 'locationTracking'
        }
        await this.getPersonnelDetail(this.personnelId)
      },
    },
    currentBtn(value) {
      if (value === 'trajectory') {
        // 打开历史轨迹的弹框
        this.$emit('operateTrajectory', {
          visible: true,
          personnelId: this.personnelId,
          tagCode: this.tagCode,
        })
      }
    },
  },
  async created() {
    await this.getPersonnelDetail(this.personnelId)
    await this.getAllPersonnelInfo()
    await this.getCodeIdMap()
  },
  destroyed() {
    clearInterval(this.currentPersonAreaNameitv)
    this.currentPersonAreaNameitv = null
  },
  mounted() {
    // 监听实时人员数据更新的事件
    window.addEventListener('setNearByList', this.positionListHandler)
    // 监听取消跟随的时间
    window.addEventListener('cancelFollow', this.cancelFollowHandler)
    // 监听是否查看历史轨迹事件
    window.addEventListener('HistoricalTrajectory', this.historicalTrajectoryHandler)
    this.cloudRender.Dispatch.on('PosViewerMarker', this.markerClick)
    setTimeout(() => {
      this.getNearbyCamera()
    }, 1000);
    this.followTimer = setInterval(() => {
      const sameX = this.currentPosition.x === this.oldPosition.x
      const sameY = this.currentPosition.y === this.oldPosition.y
      const sameZ = this.currentPosition.z === this.oldPosition.z
      if(!sameX || !sameY || !sameZ){
        // 当前人员位置发生改变重新获取附近摄像头
        this.getNearbyCamera()
      }
    }, 5000)
  },
  methods: {
    // 监控列表
    async getTableData() {
      const [err, res] = await iOTDeviceApi.getDeviceWithDetailPageList({
        ...this.search,
        deviceTypeCode: 'Camera',
        skipCount: (this.initPagination.pageNum - 1) * this.initPagination.pageSize,
        maxResultCount: this.initPagination.pageSize,
      })
      // console.log("监控列表",res);
      if (!err) {
        this.monitorList = res.items || []
        // this.tableData = res.items || []
        // this.initPagination.total = res.totalCount
        // await this.getCamerasHasPosition()
      }
    },
    markerClick(e) {
      // 左键点击并且有id
      if (e.type === 1 && !isEmpty(e.id)) {
        if (this.tagCode === e.id) {
          this.currentBtn = 'locationTracking'
          this.isFollow = true
        }
      }
    },
    // 获取附近摄像头
    async getNearbyCamera() {
      if (!this.currentPosition) return
      console.log('this.nearbyNumber', this.nearbyNumber)
      const [err, res] = await tag3DCameraPositionsApi.getNearbyCameras({
        x: this.currentPosition.x,
        y: this.currentPosition.y,
        _number: this.nearbyNumber,
      })
      if (!err && res.length) {
        if (!isEqual(this.monitorList[0], res[0])) {
          let monitorList_temp = [res[0], res[1]]
          this.monitorList = monitorList_temp
        }
        this.currentMonitor = res[0]
        if (this.monitorList.length == 0) {
          //如果获取不到最近摄像头数据，就从监控列表中取最近两条数据
          this.getTableData()
        }
      }
    },
    // 获取人员详情信息以及所在风险区域
    async getPersonnelDetail(personnelId) {
      this.personnelDetail = this.$options.data().personnelDetail
      const [err, res] = await eafOrganizationUnitUserApi.getUserDetail({ id: personnelId })
      if (!err && !isEmpty(res)) {
        this.personnelDetail.name = res.name
        this.personnelDetail.phoneNumber = res.phoneNumber
        // 没有岗位信息
        // this.personnelDetail.post = head(res.userPosts)?.postName
        this.personnelDetail.department = head(res.orgUnits)?.organizationUnitName
        if (!isEmpty(res.extraProperties?.Avatar)) {
          this.personnelDetail.avatar = await this.getImgContent(res.extraProperties?.Avatar)
        }
        if (window.VUE_APP_FILE_SERVER && !isEmpty(res.extraProperties?.AvatarUrl)) {
          // 低代码头像配置
          this.personnelDetail.avatar = `${window.VUE_APP_FILE_SERVER}${res.extraProperties?.AvatarUrl}`
        }
        this.personnelDetail.userName = res.userName // 工号
      }
      this.getCurrentPersonAreaName()
      this.currentPersonAreaNameitv = setInterval(() => {
        this.getCurrentPersonAreaName()
      }, 60000);
    },
    // 获取当前人员实时区域名
    async getCurrentPersonAreaName(){
      const cacheStr = localStorage.getItem("tongre_currentPersonListCache")
      const cacheData = JSON.parse(cacheStr)
      const currentPersonInfo = cacheData.filter(item=>item.userName == this.personnelDetail.name)
      if(currentPersonInfo.length == 0){return}
      const [err, res] = await personnelLocationApi.getAreaByMapId({ mapId: currentPersonInfo[0].mapId })
      if(res.code == '0'){
        this.personnelBelongAreaName = res.msg
      }else{
        this.personnelBelongAreaName = res.data.areaName
      }
    },
    // 获取图片base64
    async getImgContent(fileId) {
      // 获取图片内容
      const [error, result] = await fileApi.getPublicImageBaseString(fileId)
      if (!error && !isEmpty(result)) {
        return `data:image/png;base64,${result.base64}`
      }
      return ''
    },
    // 跟随操作
    async track() {
      if (this.isTrajectory) {
        this.$message.warning({
          showClose: true,
          message: '请先退出轨迹查询',
        })
        return
      }
      this.currentBtn = 'locationTracking'
      if (this.isFollow) {
        // 取消跟随
        await this.cloudRender.PosViewer.cancelPerspectiveFollow()
      } else {
        this.getNearbyCamera()
        this.followTimer = setInterval(() => {
          const sameX = this.currentPosition.x === this.oldPosition.x
          const sameY = this.currentPosition.y === this.oldPosition.y
          const sameZ = this.currentPosition.z === this.oldPosition.z
          if(!sameX || !sameY || !sameZ){
            // 当前人员位置发生改变重新获取附近摄像头
            this.getNearbyCamera()
          }
        }, 5000)
        // 跟随人员
        await this.cloudRender.PosViewer.setPerspectiveFollow({
          id: this.tagCode,
          personalPerspective: 2,
          angle: [5, 90],
        })
      }
      this.isFollow = !this.isFollow
    },
    // 获取所有人员信息
    async getAllPersonnelInfo() {
      const [err, res] = await eafOrganizationUnitUserApi.getOrganizationUnitUserList({
        includeOrgChild: true, // 是否查询该部门子部门人员
        skipCount: 0,
        maxResultCount: 1000,
      })
      if (!err && !isEmpty(res)) {
        this.allPersonnelInfo = res.items
      }
    },
    // 获取code和id的映射
    async getCodeIdMap() {
      const [err, res] = await personnelApi.getPersonnelPostionList({
        isBind: true,
        skipCount: 0,
        maxResultCount: 1000,
      })
      if (!err && !isEmpty(res)) {
        forEach(res, (item) => {
          this.codeIdMap[item.tagCode] = item.id
        })
      }
    },
    // 点击附近的人
    async nearbyPeople() {
      if (this.isTrajectory) {
        this.$message.warning({
          showClose: true,
          message: '请先退出轨迹查询',
        })
        return
      }
      // 获取附近的人时如果处于跟随状态，则取消跟随
      this.currentBtn = 'peopleNearby'
      if (this.isFollow) {
        this.isFollow = false
        if (this.followTimer) {
          clearInterval(this.followTimer)
          this.followTimer = null
        }
        // 取消跟随
        await this.cloudRender.PosViewer.cancelPerspectiveFollow()
      }
    },
    async searcheTrajectory() {
      this.currentBtn = 'trajectory'
      if (this.isFollow) {
        this.isFollow = false
        // 取消跟随
        await this.cloudRender.PosViewer.cancelPerspectiveFollow()
      }
    },
    // 监听获取实时定位人员数据
    positionListHandler(e) {
      if (!isEmpty(e?.detail?.position)) {
        // 获取当前人员的信息（坐标位置）
        const currentInfo = find(e.detail.position, (item) => {
          return item.tagId === this.tagCode
        })
        console.log('实时点位人员数据')
        this.oldPosition = JSON.parse(JSON.stringify(this.currentPosition))
        this.currentPosition = currentInfo
        // 当前这个人正有位置数据时
        if (!isEmpty(currentInfo)) {
          // 把当前人员筛选出去
          const nearList = filter(e.detail.position, (item) => {
            return item.tagId !== this.tagCode
          })
          this.nearbyList = map(nearList, (item) => {
            const detail = find(this.allPersonnelInfo, (i) => {
              return i.id === this.codeIdMap[item.tagId]
            })
            if (!isEmpty(detail)) {
              const dx = Math.abs(item.x - currentInfo.x)
              const dy = Math.abs(item.y - currentInfo.y)
              const dz = Math.abs(item.z - currentInfo.z)
              const distance = Math.sqrt(
                Math.pow(dx, 2) + Math.pow(dy, 2) + Math.pow(dz, 2)
              ).toFixed(2)
              return {
                id: detail.id,
                tagCode: item.tagId,
                name: detail.name,
                department: head(detail.orgUnits)?.organizationUnitName,
                distance,
              }
            }
          })
          // 筛选间距在最大距离设置范围内的人员
          this.nearbyList = filter(this.nearbyList, (item) => {
            return item?.distance <= this.nearMaxDistance
          })
          this.nearByPage.total = this.nearbyList.length
        }
      }
    },
    // 附近的人切换页码
    handlePageChange(val) {
      this.nearByPage.pageNo = val
    },
    // 获取附近的人某个人的详情并跟随
    async getDetail(item) {
      // 跟随该人员
      await this.cloudRender.PosViewer.setPerspectiveFollow({
        id: item.tagCode,
        personalPerspective: 2,
        angle: [5, 90],
      })
      this.isFollow = true
      this.currentBtn = 'locationTracking'
      const openEvent = new CustomEvent('openComponent', {
        detail: {
          toCom: {
            code: 'PersonnelInfo',
            origin: 'tag',
            name: '人员信息',
          },
          type: 'tags',
          props: {
            personnelId: item.id,
            tagCode: item.tagCode,
          },
        },
      })
      window.dispatchEvent(openEvent)
    },
    async cancelFollowHandler() {
      if (this.isFollow) {
        this.isFollow = false
        // 取消跟随
        await this.cloudRender.PosViewer.cancelPerspectiveFollow()
      }
      if (this.followTimer) {
        clearInterval(this.followTimer)
        this.followTimer = null
      }
    },
    // 监听是否查看历史轨迹
    historicalTrajectoryHandler(e) {
      this.isTrajectory = e.detail?.isOpen
      if (!e.detail?.isOpen && this.currentBtn === 'trajectory') this.currentBtn = ''
    },
  },
  beforeDestroy() {
    // 解绑事件
    window.removeEventListener('setNearByList', this.positionListHandler)
    window.removeEventListener('cancelFollow', this.cancelFollowHandler)
    window.removeEventListener('HistoricalTrajectory', this.historicalTrajectoryHandler)
    this.cloudRender.Dispatch.off('PosViewerMarker', this.markerClick)
    if (this.isFollow) {
      // 取消跟随
      this.cloudRender.PosViewer.cancelPerspectiveFollow()
    }
    if (this.followTimer) {
      clearInterval(this.followTimer)
      this.followTimer = null
    }
  },
}
</script>

<style lang="scss" scoped>
.btn_normal {
  background: url('../../assets/images/button_blue.png');
  background-size: 100% 100%;
}

.btn_choosed {
  background: url('../../assets/images/button_yellow.png');
  background-size: 100% 100%;
}

.table-choosed {
  background: url('../../assets/images/control/table_choosed.png');
  background-size: 100% 100%;
}

.head-bg {
  background: url('../../assets/images/control/table_head.png');
  background-size: 100% 100%;
}

.area-box {
  &::-webkit-scrollbar {
    background-color: transparent;
    width: 9px;
  }
  &::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: #104a70;
    color: #104a70;
  }
}
</style>
